import {
  OPT_WORKFLOWS_LIST_STATUS_ACTIVE,
  OPT_WORKFLOWS_LIST_STATUS_ACTIVE_VALUE,
  OPT_WORKFLOWS_LIST_STATUS_ALL,
  OPT_WORKFLOWS_LIST_STATUS_ALL_VALUE,
  OPT_WORKFLOWS_LIST_STATUS_DRAFT,
  OPT_WORKFLOWS_LIST_STATUS_DRAFT_VALUE,
  OPT_WORKFLOWS_LIST_STATUS_PAUSED,
  OPT_WORKFLOWS_LIST_STATUS_PAUSED_VALUE
} from 'Constants/'
import { Select } from 'mailup-web-components'
import { searchState } from 'Pages/WorkflowsList/recoil/state/search'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

export const InputStatus = ({ onChange }) => {
  const intl = useIntl()
  const [{ status }, setSearchParams] = useRecoilState(searchState)

  const { current: options } = useRef([
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_STATUS_ALL }),
      value: OPT_WORKFLOWS_LIST_STATUS_ALL_VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_STATUS_DRAFT }),
      value: OPT_WORKFLOWS_LIST_STATUS_DRAFT_VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_STATUS_ACTIVE }),
      value: OPT_WORKFLOWS_LIST_STATUS_ACTIVE_VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_STATUS_PAUSED }),
      value: OPT_WORKFLOWS_LIST_STATUS_PAUSED_VALUE
    }
  ])

  const handleInputChange = (e) => {
    const val = e
    setSearchParams((prev) => ({
      ...prev,
      status: val
    }))
  }

  return (
    <Select
      searchable={false}
      options={options}
      onChange={handleInputChange}
      value={status}
    />
  )
}

InputStatus.propTypes = {
  onChange: PropTypes.func
}
